
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[...searchpages]",
      function () {
        return require("private-next-pages/search/[...searchpages]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[...searchpages]"])
      });
    }
  